import messaging from '@react-native-firebase/messaging';
import { Platform } from 'react-native';

export default class InitialNotificationParser {
  setup(callback: any) {
    this.callback = callback;
    this.removeOpenedEventHandler = undefined;

    if (Platform.OS === 'web') {
      this.onInitialNotificationReady(null);
    } else {
      messaging().getInitialNotification()
      .then((notification) => this.onInitialNotificationReady(notification ? notification : null));
    }
  }

  cleanup() {
    this.callback = undefined;
    if (this.removeOpenedEventHandler) {
      console.log('[Notifications:InitialNotificationParser] removing opened event handler');
      this.removeOpenedEventHandler();
      this.removeOpenedEventHandler = undefined;
    }
  }

  setupNotificationOpenedEvent(eventCallback: any) {
    if (Platform.OS === 'web') {
      return;
    }

    messaging().getInitialNotification()
    .then((notification) => {
      console.log('[Notifications:InitialNotificationParser] initial param set');
      if (notification) {
        let autoNavigate = this.parse(notification);
        if (autoNavigate) {
          eventCallback(notification, autoNavigate);
        }
      }
    });

    this.removeOpenedEventHandler = messaging().onNotificationOpenedApp((message) => {
      console.log('[Notifications:InitialNotificationParser] got a notification');
      let autoNavigate = this.parse(message);
      if (autoNavigate) {
        eventCallback(message, autoNavigate);
      }
    });
  }

  onInitialNotificationReady(message: any) {
    console.log('[Notifications:InitialNotificationParser] handling initial push notification');
    let autoNavigate = this.parse(message);
    if (this.callback) {
      this.callback(message, autoNavigate);
    }
  }

  parse(message: any) {
    if (!message) {
      console.log('[Notifications:InitialNotificationParser] no push message');
      return undefined;
    }

    const id = message.notification.data.notificationId;
    if (id && id.match(/^[a-f0-9]+$/)) {
      console.log('[Notifications:InitialNotificationParser] push notification for notifications found with id', id);
      return {
        id,
        type: 'notification',
      };
    }

    console.warn('[Notifications:InitialNotificationParser] not a push message for notifications', message.notification.data);
    return undefined;
  }
}
